var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 26.6667V17.5C31.6666 11.0567 26.4433 5.83333 19.9999 5.83333C13.5566 5.83333 8.33325 11.0567 8.33325 17.5V26.6667H5.83325V31.6667H34.1666V26.6667H31.6666Z",
    fill: "#FFB74D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.6667C22.7614 36.6667 25 34.4281 25 31.6667C25 28.9052 22.7614 26.6667 20 26.6667C17.2386 26.6667 15 28.9052 15 31.6667C15 34.4281 17.2386 36.6667 20 36.6667Z",
    fill: "#FFB74D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 3.33333H18.3333V10.39H21.6666V3.33333Z",
    fill: "#FFB74D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6667C17.2383 26.6667 15 28.905 15 31.6667H25C25 28.905 22.7617 26.6667 20 26.6667Z",
    fill: "#DB7C29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.fc29557b6b3ff86caf8a33360004b967.svg";
export { ForwardRef as ReactComponent };